import React from 'react';
import { Container } from 'react-bootstrap';
import '../css/404.css';

class NotFound extends React.Component{
    render(){
        return(
            <Container>
                <div id="main">
                    <div className="fof">
                        <h1>Error 404</h1>
                        <h2>Pagina no encontrada</h2>
                    </div>
                </div>
            </Container>
        )
    }
}

export default NotFound